module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/marriageregistration-fce15fc8a3b0781e2c2a3fc2b95bccc7.webp";